import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;

export const ModalContainer = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  position: relative;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 24px 0px 24px;
  position: relative;
`;

export const CalendarIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;

`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 24px;
  background: none;
  border: none;
  font-size: 32px;
  color: #636363;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #3D3D3D;
  }
`;

export const ModalTitle = styled.h2`
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 20px;
  line-height: 1em;
  text-align: center;
  color: #3D3D3D;
  margin: 16px 0 0 0;
  padding: 12px 24px;
`;

export const ModalContent = styled.div`
  padding: 16px;
`;

export const ModalMessage = styled.p`
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 14px;
  line-height: 1.542;
  text-align: center;
  color: #636363;
  margin: 0 0 40px 0;

  strong {
    color: #636363;
    font-weight: 700;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
`;

export const NoButton = styled.button`
  flex: 1;
  padding: 13px 24px;
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 16px;
  line-height: 1.542;
  text-align: center;
  color: #3D3D3D;
  background-color: transparent;
  border: 1px solid #3D3D3D;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #3D3D3D;
    color: #FFFFFF;
  }
`;

export const YesButton = styled.button`
  flex: 1;
  padding: 13px 24px;
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 16px;
  line-height: 1.542;
  text-align: center;
  color: #FFFFFF;
  background-color: #0B29FB;
  border: 1px solid #0B29FB;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #0A25E3;
    border-color: #0A25E3;
  }
`;
